import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-transfer-gifts-list',
  templateUrl: './transfer-gifts-list.component.html',
  styleUrls: ['./transfer-gifts-list.component.scss']
})
export class TransferGiftsListComponent extends GridBaseCase {
  gifsearchValue: any="";// 搜索条件
  tabstranIndex: number = 0;
  pageName: string;
  tabsType:string="in";
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表
  current_obj: any = {};//当前对象
  giftsCategoryID: any; // 产品分类的id
  _tempArray: Array<any> = [];
  imgUrlArr: Array<any> = [];

  pageNameone: number = 0; // 产品所属于产品
  ID: string = "";
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    //debugger;
    if(sessionStorage.getItem(this.pageName+"_page")){
            this.tabstranIndex=parseInt(sessionStorage.getItem(this.pageName+"_page"));
      if(this.tabstranIndex==1){
        this.tabsType="out";
      }
  sessionStorage.removeItem(this.pageName+"_page");
       }
    this.LoadData(1);
  }

  ngOnInit() {
  }
  // 搜索条件
  serarEvent(ev, searchType) {
    this.LoadData(1);
  }
  // 切换
  tabstranEvent(num,typeName) {
    const that = this;
    //debugger;
    that.tabstranIndex = num;
     sessionStorage.setItem(that.pageName+"_page",that.tabstranIndex.toString());
    that.tabsType=typeName;
    that.LoadData(1);
  }
  /**
   * 
   * @param e 跳转页面
   */
  EventLink(e, item) {
    const that=this;
    // let json = {
    //   tabsTypeName:this.tabsType,
    //   ID: item.ID,
    //   ImgUrl: item.ImgUrl,
    //   FK_TBStore_ID: item.FK_TBStore_ID,//赠品id
    //   SignerName: item.SignerName, // 签收人
    //   FK_TBStore_Name: item.FK_TBStore_Name, // 门店名称
    //   SignTimeEffect: item.SignTimeEffect,// 日期
    //   SignState: item.SignState, // 返回的签收状态
    //   MessageFeedback: item.MessageFeedback // 备注
    // };
    item["tabsTypeName"]=this.tabsType;
     sessionStorage.setItem(that.pageName+"_page",that.tabstranIndex.toString());
    this.com.setHistoryUrl();
    this.com.Go("/tabs/contact/TransferGiftsDetail/" + this.com.getNowDatetime,{
      JsonData:JSON.stringify(item)
    });
  }


  
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  } 
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.dataArrayList = [];
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    let _dy: any = {
      "type":this.tabsType,
      "StoreName":this.gifsearchValue
    };
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBGiftsCargoPlanInfoSNC";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody = JSON.stringify(_dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(item => {
          if(item["CargoDateTime"]){
            
            item["CargoDateTime"]=item["CargoDateTime"].replace(/-/g,"/").replace("Z",'').replace("-00:00",'').replace("T","");
          }
        });
        that.dataArrayList = data.Status.Datas;
        that.baseService.arrayData = data.Status.Datas;
        console.log("dataArrayList",that.dataArrayList);
         /****上拉加载数据begin****/
         that.RecordCount = data.Status.RecordCount;
         if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
           that.infiniteScroll.disabled = true;
         } else {
           that.infiniteScroll.disabled = false;
         }
         /****上拉加载数据end****/
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

}
